module.exports = __webpack_public_path__ + "static/dwlogo-b3a953638f5a6431f4a90198a926ea28.svg";